import gql from "graphql-tag";
const resetMutation = gql`
  mutation resetPassword($resetPassword: ResetPasswordInput!) {
    resetPassword(resetPassword: $resetPassword) {
        success,
        mailSent,
        notConfirmed,
        message,
        err
    }
  }
`;

export default resetMutation;
